import {
  IGetPostingPlansApiResponse,
  IGetPostingPlansResult,
  IPostingPlanApiModel,
  IPostingPlanViewEntity,
} from '../types';

const toPostingPlanViewEntity = (model: IPostingPlanApiModel): IPostingPlanViewEntity => {
  return {
    id: model.id,
    name: model.name,
    description: model.description,
    basePrice: model.basePrice,
    finalPrice: model.finalPrice,
    nextBillingDate: model.nextBillingDate,
    createdAt: model.createdAt,
    updatedAt: model.updatedAt,
    billingInterval: model.billingInterval,
    intervalCount: model.intervalCount,
  };
};

const toGetPostingPlansResult = (
  response: IGetPostingPlansApiResponse,
): IGetPostingPlansResult => {
  return {
    data: response.data.map(toPostingPlanViewEntity),
  };
};

export const PostingPlanAdapters = {
  toGetPostingPlansResult,
  toPostingPlanViewEntity,
};
